import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box } from "@mui/material";
import styles from "./dataTable.module.scss";
import { styled } from "@mui/system";
import TableCheckBox from "../checkBox/TableCheckBox";
import PropTypes from "prop-types";

const StyledDataGrid = styled(DataGrid)((props) => ({
  "& .MuiDataGrid-columnHeaders": {
    borderLeft: "4px solid transparent !important",
  },
  "& .MuiDataGrid-row:nth-of-type(even)": {
    backgroundColor: "rgba(0, 170, 230, 0.03)",
    cursor: "default",
  },
  "& .MuiDataGrid-row:hover": {
    cursor: "default",
    backgroundColor: "rgba(0, 170, 230, 0.08)",
  },
  "& .MuiDataGrid-virtualScrollerContent": {
    width: "auto !important",
  },
  "& .MuiDataGrid-virtualScroller": {},
  "& .MuiDataGrid-columnHeader": {},
  "& .MuiDataGrid-cell": {
    border: "none",
    // minHeight: "64px !important", /needed later
    // maxHeight: "none !important",
  },
  "& .MuiDataGrid-row": {
    borderBottom: "1px solid #D5D2CE",
    background: "#F4F9FF",
    borderLeft: "4px solid transparent !important",
  },
  "& .Mui-selected": {
    borderLeft: "4px solid  #0B72D9 !important",
  },
  "& .MuiDataGrid-iconButtonContainer": {
    visibility: "visible !important",
    width: "auto !important",
  },
  "& .MuiDataGrid-sortIcon": {
    color: "#00AAE6",
    opacity: "inherit !important",
  },
  "& .MuiDataGrid-cellContent": {
    color: "#2C3E50 !important",
  },
}));

const DataTable = (props) => {
  const {
    columns,
    rows = [],
    rowHeight = 64,
    isShowMessage,
    isShowTableWhenNoResult,
    isCheckboxSelection = true,
    sortModel = [],
    noDataFound = () => {
      return <Box>No Data found</Box>;
    },
    inGroupTable,
    ...tableprops
  } = props;

  return (
    <Box className={styles.dataTableContainer} data-testid="data-table">
      {rows.length > 0 || isShowTableWhenNoResult ? (
        <StyledDataGrid
          disableSelectionOnClick={true}
          getRowId={(row) => row.id}
          rowHeight={rowHeight}
          autoHeight={true}
          rows={rows}
          columns={columns}
          className={styles.dataTable}
          sortingOrder={["asc", "desc", null]}
          sortModel={sortModel}
          isShowTableWhenNoResult={isShowTableWhenNoResult}
          data-testid="show-table-when-no-result"
          checkboxSelection={isCheckboxSelection}
          inGroupTable={inGroupTable}
          slots={{
            noRowsOverlay: () => noDataFound(),
            BaseCheckbox: TableCheckBox,
          }}
          {...tableprops}
        />
      ) : (
        ""
      )}
    </Box>
  );
};
export default DataTable;
DataTable.propTypes = {
  columns: PropTypes.any,
  rows: PropTypes.any,
  rowHeight: PropTypes.any,
  isShowMessage: PropTypes.any,
  isShowTableWhenNoResult: PropTypes.any,
  isCheckboxSelection: PropTypes.any,
  sortModel: PropTypes.any,
  noDataFound: PropTypes.any,
};
